import Component from '@glimmer/component';
import { action } from '@ember/object';
import { service } from '@ember/service';

/*
  args
    - item
    - columnsToDisplay - number 1, 2, or 3
    - displayOneColumn (boolean)
    - onFilterByGroup(group)
*/

export default class extends Component {
  @service taskService;

  @action
  handleCreateTask() {
    let newTask = this.taskService.createRecord({
      contactId: this.args.item.contact.id,
    });
    this.args.item.notComplete = [newTask, ...this.args.item.notComplete];
  }

  @action
  handleTaskSaved() {
    this.args.item.afterTaskSaved();
  }

  @action
  handleCancelEditTask(task) {
    if (task.isNew) {
      // remove the task from the list if it's new
      this.args.item.notComplete = this.args.item.notComplete.filter(
        (x) => !x.isNew,
      );
      this.args.item.afterTaskSaved();
    }
  }

  @action
  handleTaskDeleted(task) {
    this.args.item.recentCompleted = this.args.item.recentCompleted.filter(
      (x) => x.id !== task.id,
    );
    this.args.item.notComplete = this.args.item.notComplete.filter(
      (x) => x.id !== task.id,
    );
    this.args.item.afterTaskSaved();
  }
}
